import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type ImsForecastingInvoiceStatus = z.infer<
  typeof imsForecastingInvoiceStatus
>;
export const imsForecastingInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentImsForecastingInvoice = {
  name: "getCurrentImsForecastingInvoice" as const,
  input: z.null(),
  output: imsForecastingInvoiceStatus.nullable(),
};
